import axios from "axios";


export const fetchLabBillId = (id) => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/Lab/OpenLabEntries/${id}`);
  };

  export const addLabBillId = (data) => {
    return axios.post(`https://arogyanxtdevapi.fundaclear.in/api/Lab/LabEntries`, data);
  };